<template>
	<div class="return-to-container">
		<div class="loading-spinner">
			<div class="spinner"></div>
			<p>Utente già autenticato. Reindirizzamento all'editor in corso...</p>
		</div>
	</div>
</template>

<script setup lang="ts">
import { onMounted } from "vue";
import { useRoute } from "vue-router";
import axios from "@/axiosInstance";
import { API_URL, EDITOR_BASE_URL } from "@/config";

const route = useRoute();

onMounted(async () => {
	const returnTo = route.query.returnTo as string | undefined;

	if (!returnTo) {
		// Se non c'è returnTo, vai alla dashboard
		window.location.href = "/dashboard";
		return;
	}

	try {
		const API_BASE = (API_URL || "").replace(/\/$/, "");
		const editorBase = new URL(
			EDITOR_BASE_URL || "https://d12f-151-74-127-120.ngrok-free.app",
		);

		// Ottieni il ticket
		const response = await axios.get(
			`${API_BASE}/auth/editor/ticket?returnTo=${returnTo}`,
		);
		const ticketId = response.data.ticketId;

		console.log("ticket =", ticketId);

		// Costruisci l'URL dell'editor e redirecta
		const editorSchemaUrl = new URL(`/sso/${ticketId}`, editorBase).toString();

		// Mostra la pagina per un attimo prima di reindirizzare
		setTimeout(() => {
			window.location.href = editorSchemaUrl;
		}, 2000);
	} catch (error) {
		console.error("Errore durante il redirect all'editor:", error);
		// In caso di errore, redirecta alla dashboard
		window.location.href = "/dashboard";
	}
});
</script>

<style scoped>
.return-to-container {
	display: flex;
	justify-content: center;
	align-items: center;
	min-height: 100vh;
	background: url("@/assets/sfondo-bg-1.png") no-repeat center center fixed;
	background-size: cover;
	position: relative;
}

.return-to-container::before {
	content: "";
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background: rgba(0, 0, 0, 0.5); /* Overlay scuro per leggibilità */
	z-index: 1;
}

.loading-spinner {
	text-align: center;
	color: white;
	position: relative;
	z-index: 2;
}

.spinner {
	border: 4px solid rgba(255, 255, 255, 0.3);
	border-top: 4px solid white;
	border-radius: 50%;
	width: 50px;
	height: 50px;
	animation: spin 1s linear infinite;
	margin: 0 auto 20px;
}

@keyframes spin {
	0% {
		transform: rotate(0deg);
	}
	100% {
		transform: rotate(360deg);
	}
}

.loading-spinner p {
	font-size: 16px;
	font-weight: 500;
}
</style>
